import React from "react";

const ParagraphReadingIcon = (props) => (
<svg
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
>
  <rect
    x="0.714844"
    y="0.713867"
    width="38.5712"
    height="38.5716"
    rx="19.2856"
    fill="none"
  />
  <path
    d="M17.1437 19.2854C19.1161 19.2854 20.7151 17.6864 20.7151 15.714C20.7151 13.7416 19.1161 12.1426 17.1437 12.1426C15.1713 12.1426 13.5723 13.7416 13.5723 15.714C13.5723 17.6864 15.1713 19.2854 17.1437 19.2854Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M17.1434 22.1426C13.593 22.1426 10.7148 25.0207 10.7148 28.5711V29.2854H23.572V28.5711C23.572 25.0207 20.6938 22.1426 17.1434 22.1426Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M27.6133 18.7951C28.685 17.7235 29.287 16.27 29.287 14.7545C29.287 13.239 28.685 11.7855 27.6133 10.7139"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M25.0879 16.2697C25.4897 15.8679 25.7156 15.3228 25.7156 14.7545C25.7156 14.1862 25.4897 13.6411 25.0879 13.2393"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);

export default ParagraphReadingIcon;